<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-success shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-6">
                <h1 class="display-3 text-white">
                  Pelayanan Pajak Lainnya
                  <span>Kabupaten Ketapang</span>
                </h1>
                <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    class="mb-3 mb-sm-0"
                    type="info"
                    textColor="white"
                    icon="fa fa-arrow-left"
                    @click="goback()"
                  >Kembali</base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-hotel" type="primary" rounded class="mb-4"></icon>
                  <h6 class="text-primary text-uppercase">E-SPTPD Hotel</h6>
                  <p class="description mt-3">
                    Pendataan penghasilan hotel secara mandiri.
                  </p>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="primary"
                    class="mt-4"
                    @click="goBphtbPermohonan()"
                  >E-SPTPD Hotel</base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-coffee" type="success" rounded class="mb-4"></icon>
                  <h6 class="text-success text-uppercase">E-SPTPD Restoran</h6>
                  <p class="description mt-3">
                    Pendataan penghasilan restoran secara mandiri.
                  </p>
                  <base-button
                    tag="a"
                    textColor="white"
                    type="success"
                    class="mt-4"
                    @click="goBphtbCekPermohonan()"
                  >E-SPTPD Restoran</base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-microphone" type="warning" rounded class="mb-4"></icon>
                  <h6 class="text-warning text-uppercase">E-SPTPD Hiburan</h6>
                  <p class="description mt-3">Pendataan penghasilan Huburan secara mandiri.</p>
                  <base-button tag="a" href="#" type="warning" class="mt-4">E-SPTPD Hiburan</base-button>
                </card>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <br />
            <hr />
            <br />
          </div>
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-car" type="info" rounded class="mb-4"></icon>
                  <h6 class="text-info text-uppercase">E-SPTPD Parkir</h6>
                  <p class="description mt-3">Pendataan penghasilan parkir secara mandiri.</p>
                  <base-button tag="a" href="#" type="info" class="mt-4">E-SPTPD Parkir</base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-shower" type="danger" rounded class="mb-4"></icon>
                  <h6 class="text-danger text-uppercase">Tagihan Air Tanah</h6>
                  <p class="description mt-3">Melihat tagihan Air tanah berdasarkan NPWPD.</p>
                  <base-button tag="a" href="#" type="danger" class="mt-4">Lihat</base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-print" type="primary" rounded class="mb-4"></icon>
                  <h6 class="text-primary text-uppercase">Cetak Kartu Data</h6>
                  <p class="description mt-3">Mencetak kartu data berdasarkan NPWPD.</p>
                  <base-button tag="a" href="#" type="primary" class="mt-4">Cetak</base-button>
                </card>
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <br />
            <hr />
            <br />
          </div>
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-print" type="success" rounded class="mb-4"></icon>
                  <h6 class="text-success text-uppercase">Cetak E-SPTPD Online</h6>
                  <p class="description mt-3">Mencetak E-SPTPD online yang sudah di input pada menu E-sptpd.</p>
                  <base-button tag="a" href="#" type="success" class="mt-4">Cetak</base-button>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "PajakLainnya",
  components: {},
  methods: {
    goBphtbPermohonan() {
      this.$router.push("/bphtb/permohonan");
    },
    goBphtbCekPermohonan() {
      this.$router.push("/bphtb/cek-permohonan");
    },
    goback() {
      this.$router.go(-1);
    },
  },
};
</script>